import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';

const MyItems = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      navigate('/login');
      return;
    }
    fetchItems();
  }, [user, navigate]);

  const fetchItems = async () => {
    try {
      const response = await axios.get('/api/items/my/items');
      setItems(response.data);
    } catch (error) {
      console.error('Lỗi khi tải món đồ:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleHide = async (id, status) => {
    try {
      await axios.put(`/api/items/${id}`, { status });
      fetchItems();
    } catch (error) {
      alert(error.response?.data?.error || 'Cập nhật thất bại');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bạn có chắc muốn xóa món đồ này?')) {
      return;
    }

    try {
      await axios.delete(`/api/items/${id}`);
      fetchItems();
    } catch (error) {
      alert(error.response?.data?.error || 'Xóa thất bại');
    }
  };

  if (!user) {
    return null;
  }

  return (
    <div className="container" style={{ marginTop: '40px' }}>
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', flexWrap: 'wrap', gap: '12px' }}>
        <h1>Món Đồ Của Tôi</h1>
        <button onClick={() => navigate('/post-item')} className="btn btn-primary">
          + Đăng Món Đồ Mới
        </button>
      </div>

      {loading ? (
        <div className="loading">Đang tải...</div>
      ) : items.length === 0 ? (
        <div className="empty-state">
          <h3>Bạn chưa đăng món đồ nào</h3>
          <p>Hãy bắt đầu chia sẻ những món đồ không dùng đến!</p>
          <button onClick={() => navigate('/post-item')} className="btn btn-primary" style={{ marginTop: '16px' }}>
            Đăng Món Đồ Đầu Tiên
          </button>
        </div>
      ) : (
        <div className="item-list">
          {items.map(item => (
            <article key={item.id} className="item-list-item">
              {item.image_url ? (
                <img 
                  src={item.image_url} 
                  alt={item.title} 
                  className="item-list-image" 
                  onClick={() => navigate(`/item/${item.id}`)}
                  loading="lazy"
                />
              ) : (
                <div 
                  className="item-list-image placeholder" 
                  onClick={() => navigate(`/item/${item.id}`)}
                  aria-label="Không có hình ảnh"
                >
                  📦
                </div>
              )}
              <div className="item-list-content">
                <h2 
                  className="item-list-title"
                  onClick={() => navigate(`/item/${item.id}`)}
                >
                  {item.title}
                </h2>
                <p className="item-list-description">{item.description || 'Không có mô tả'}</p>
                <div className="item-list-meta">
                  <span className={`badge ${
                    item.status === 'available' ? 'badge-success' :
                    item.status === 'hidden' ? 'badge-secondary' :
                    'badge-warning'
                  }`}>
                    {item.status === 'available'
                      ? 'Còn khả dụng'
                      : item.status === 'hidden'
                        ? 'Đang ẩn'
                        : 'Đã được nhận'}
                  </span>
                </div>
                <div className="item-actions" style={{ marginTop: '12px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  <button onClick={(e) => { e.stopPropagation(); navigate(`/item/${item.id}`); }} className="btn btn-secondary" style={{ flex: '1 1 120px', padding: '10px' }}>
                    Xem
                  </button>
                  {item.status !== 'taken' && (
                    <button
                      onClick={(e) => { e.stopPropagation(); handleHide(item.id, item.status === 'hidden' ? 'available' : 'hidden'); }}
                      className="btn btn-outline"
                      style={{ flex: '1 1 120px', padding: '10px' }}
                    >
                      {item.status === 'hidden' ? 'Hiện lại' : 'Ẩn tạm'}
                    </button>
                  )}
                  <button onClick={(e) => { e.stopPropagation(); handleDelete(item.id); }} className="btn btn-danger" style={{ flex: '1 1 120px', padding: '10px' }}>
                    Xóa
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyItems;

